
import styled from "styled-components";
import { colors } from "./colors/color";
import React from "react";
import { assertNever } from "../amorg-common";
import { Icon, iconName } from "./icons/Icons";
import { Flex } from "./compositeComponents/FlexHelpers";

export type MessageCardVariants = 'success' | 'warning' | 'error' | 'info';

type MessageCardProps = {
    variant: MessageCardVariants,
    hide?: boolean,
    textAlign?: 'left' | 'center' | 'right',
    padding?: string,
    grow?: 0 | 1 | 2,
    style?: React.CSSProperties,
}

export function MessageCard(props:React.PropsWithChildren<MessageCardProps>): JSX.Element 
{
    return (props.variant === 'info' || props.variant === 'success') 
        ? <CivilizedMessageCard {...props} />
        : <BrutalMessageCard {...props} />;
}

export function BrutalMessageCard(props:React.PropsWithChildren<MessageCardProps>): JSX.Element 
{
    return (
        <StyledBrutalMessageCard {...props}>
            {props.children}
        </StyledBrutalMessageCard>
    );
}

export function CivilizedMessageCard(props:React.PropsWithChildren<MessageCardProps>): JSX.Element 
{
    const icon:iconName = 
        props.variant === 'success' ? 'status_ok'
        : props.variant === 'error' ? 'status_error'
        : props.variant === 'warning' ? 'warning'
        : 'info';

    return (
        <StyledCivilizedMessageCard {...props}>
            <Flex gap={8} alignItems="center">
                <Icon name={icon} color={getVariantColor(props.variant)} />
                <div>
                    {props.children}
                </div>
            </Flex>
        </StyledCivilizedMessageCard>
    );
}


const StyledBrutalMessageCard = styled.div<MessageCardProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${props => getVariantColor(props.variant)};
    color: white !important;
    border-radius: 4px;
    ${({ style }) => style && `css: ${style}`};
    flex-grow: ${props => props.grow || 0};
    text-align: ${props => props.textAlign || 'center'};
    overflow-wrap: break-word;
    white-space: pre-wrap;
    visibility: ${ props => props.hide ? 'hidden' : 'visible' };
    padding: ${props => props.padding || '10px'};
`;

const StyledCivilizedMessageCard = styled(StyledBrutalMessageCard)`
    background-color: white;
    color: ${colors.text.normal} !important;
    border: 1px solid ${props => getVariantColor(props.variant)};
    border-left-width: 4px;
`;

function getVariantColor(type: MessageCardVariants): string {
    switch (type) {
        case "info":
            return colors.icon.info;
        case "success":
            return colors.icon.success;
        case "warning":
            return colors.icon.warning;
        case "error":
            return colors.icon.error;
        default:
            assertNever(type);
    }
}
